module.exports = "/_next/static/chunks/images/akira-confused-85b4ffe6b5c66aced7d13a77c557f7fa.svg";